import React, { useState, useEffect } from "react";
import { Table, Card, Select, Row, Col, Modal, Button, Tooltip } from "antd";
import { foodReviewList, exportFoodReviews } from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";
import moment from "moment";
import { arrOfMonths } from "../helper/Constant";

const { Option } = Select;

const AdminFoodReview = () => {
    const [reviews, setReviews] = useState([]);
    const [loader, setLoader] = useState(false);
    const [month, setMonth] = useState(moment().month() + 1);
    const [year, setYear] = useState(moment().year());
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentMsg, setCurrentMsg] = useState("");
    const [modalTitle, setModalTitle] = useState("");

    const arrOfYears = [];
    const currentYear = moment().year();
    for (let i = 0; i <= 5; i++) {
        arrOfYears.push(currentYear - i);
    }

    const fetchReviews = () => {
        setLoader(true);
        foodReviewList(`month=${month}&year=${year}`).then((res) => {
            let { status, resData } = ResponseFilter(res);
            if (status && resData && resData.resData) {
                setReviews(resData.resData);
            }
            setLoader(false);
        });
    };

    useEffect(() => {
        fetchReviews();
    }, [month, year]);

    const handleExport = () => {
        setLoader(true);
        exportFoodReviews({ month, year })
            .then(() => setLoader(false))
            .catch(() => setLoader(false));
    };

    const showModal = (text, title) => {
        setCurrentMsg(text);
        setModalTitle(title);
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setCurrentMsg("");
    };

    const renderSingleLine = (text) => (
        <Tooltip title={text}>
            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {text}
            </div>
        </Tooltip>
    );

    const renderExpandable = (text, title) => {
        if (!text) return "";
        const words = text.trim().split(/\s+/);
        if (words.length > 5) {
            return (
                <Tooltip title={text}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {words.slice(0, 5).join(" ")}...
                        <span
                            onClick={() => showModal(text, title)}
                            style={{ cursor: "pointer", color: "#1890ff", marginLeft: "10px" }}
                            title="View full text"
                        >
                            <i className="fa fa-eye" aria-hidden="true"></i>
                        </span>
                    </div>
                </Tooltip>
            );
        }
        return (
            <Tooltip title={text}>
                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{text}</div>
            </Tooltip>
        );
    };

    const header = (title, fullQuestion) => (
        <Tooltip title={fullQuestion}>
            <span>{title}</span>
        </Tooltip>
    );

    const columns = [
        {
            title: "Date",
            dataIndex: "created",
            key: "created",
            render: (date) => renderSingleLine(moment(date).format("DD/MM/YYYY")),
            width: 100,
            fixed: 'left'
        },
        {
            title: header("1. Quality", "1. How satisfied are you with the overall quality of food served in the canteen?"),
            dataIndex: "q1",
            key: "q1",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("2. Taste", "2. How would you rate the taste and flavor of the meals provided?"),
            dataIndex: "q2",
            key: "q2",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("3. Freshness", "3. Is the food usually served fresh and at the right temperature?"),
            dataIndex: "q3",
            key: "q3",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("4. Portion", "4. Are the portion sizes sufficient for your needs?"),
            dataIndex: "q4",
            key: "q4",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("5. Value", "5. Do you feel the food quantity matches the price paid?"),
            dataIndex: "q5",
            key: "q5",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("6. Variety", "6. How satisfied are you with the variety of menu options available?"),
            dataIndex: "q6",
            key: "q6",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("7. Healthy", "7. Are healthy and balanced meal options adequately available?"),
            dataIndex: "q7",
            key: "q7",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("8. Cleanliness", "8. How would you rate the cleanliness of the dining area?"),
            dataIndex: "q8",
            key: "q8",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("9. Hygiene", "9. How would you rate the hygiene practices followed by the canteen staff?"),
            dataIndex: "q9",
            key: "q9",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("10. Pricing", "10. Is the pricing of food items affordable and reasonable?"),
            dataIndex: "q10",
            key: "q10",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("11. Service", "11. How satisfied are you with service speed and staff behavior during peak hours?"),
            dataIndex: "q11",
            key: "q11",
            width: 130,
            render: renderSingleLine
        },
        {
            title: header("12. Improvement", "12. What is the one major improvement you would like to see in the canteen?"),
            dataIndex: "q12",
            key: "q12",
            width: 200,
            render: (text) => renderExpandable(text, "Major Improvement")
        },
        {
            title: header("13. Overall", "13. Overall, how would you rate the canteen services? (Rate from 1 to 5)"),
            dataIndex: "q13",
            key: "q13",
            width: 180,
            render: renderSingleLine
        },
        {
            title: header("14. Continue", "14. Do you think WE SHOULD CONTINUE WITH THE CURRENT FOOD VENDOR?"),
            dataIndex: "q14",
            key: "q14",
            width: 100,
            render: renderSingleLine
        },
        {
            title: header("15. Comments", "15. Additional Comments"),
            dataIndex: "q15",
            key: "q15",
            width: 250,
            render: (text) => renderExpandable(text, "Additional Comments")
        },
    ];

    return (
        <div className="body_container cm_bold">
            <div className="row d-flex align-items-center mb-4">
                <div className='col-md-6'>
                    <h3 className="mb-0">CANTEEN REVIEWS</h3>
                </div>
                <div className="col-md-6 d-flex justify-content-end align-items-center">
                    <Button
                        type="primary"
                        size="large"
                        onClick={handleExport}
                        style={{ marginRight: '10px', borderRadius: '10px', display: 'flex', alignItems: 'center' }}
                    >
                        Export Sheet
                    </Button>
                    <Select
                        style={{ width: 150, marginRight: 10 }}
                        placeholder="Select Month"
                        value={month}
                        onChange={(val) => setMonth(val)}
                    >
                        {arrOfMonths.map((m, i) => (
                            <Option key={i + 1} value={i + 1}>
                                {m}
                            </Option>
                        ))}
                    </Select>
                    <Select
                        style={{ width: 100 }}
                        placeholder="Select Year"
                        value={year}
                        onChange={(val) => setYear(val)}
                    >
                        {arrOfYears.map((y) => (
                            <Option key={y} value={y}>
                                {y}
                            </Option>
                        ))}
                    </Select>
                </div>
            </div>

            <div className="table-responsive">
                <Table
                    columns={columns}
                    dataSource={reviews}
                    rowKey="_id"
                    loading={loader}
                    pagination={false}
                    scroll={{ x: 2500 }}
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                />
            </div>

            <Modal
                title={modalTitle}
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <p>{currentMsg}</p>
            </Modal>
        </div>
    );
};

export default AdminFoodReview;
